import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import { selectEntities } from 'services/entities/selectors';
import { makeSelectCalibrations } from 'services/equipmentSets/selectors';
import { SprayEntityIds } from 'services/sprayEvents/types';
import { Calibration } from 'services/equipmentSets/types';
import { OwnProps } from './index';

const selectSprayEntityIds = (
    state: AppState,
    props: OwnProps
): SprayEntityIds => props.entityIds;

const selectEntitiesByCalibration = createDeepEqualSelector(
    makeSelectCalibrations(),
    selectSprayEntityIds,
    selectEntities,
    (calibrations: Calibration[], entityIds, entities) => {
        const entitiesByCalibration: string[] = [];

        calibrations.forEach(
            ({ rowSpacingMin, rowSpacingMax }: Calibration, index) => {
                const entitiesForThisCalibration: string[] = [];

                entityIds &&
                    entityIds.forEach(entityId => {
                        if (
                            entityId &&
                            entities[entityId] &&
                            entities[entityId].rowSpacing
                        ) {
                            const { rowSpacing } = entities[entityId];

                            if (
                                rowSpacing &&
                                rowSpacing >= rowSpacingMin &&
                                rowSpacing <= rowSpacingMax
                            ) {
                                entitiesForThisCalibration.push(
                                    entities[entityId].name
                                );
                            }
                        }
                    });

                entitiesByCalibration[index] = entitiesForThisCalibration.join(
                    ', '
                );
            }
        );

        return entitiesByCalibration;
    }
);

const makeSelectEntitiesByCalibration = (): typeof selectEntitiesByCalibration =>
    selectEntitiesByCalibration;

export { selectSprayEntityIds, makeSelectEntitiesByCalibration };
